import { Component } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { NgForm } from '@angular/forms';
import {AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2/database';


import {Injectable} from '@angular/core';
import {Http, Response, Headers} from "@angular/http";
import 'rxjs/Rx';
import {ToastrService} from 'toastr-ng2';
import {PushNotificationService} from '../../push-notification/push-notification.service';


@Component({
  selector: 'app-view-news',
  templateUrl: './view-news.component.html',
  styleUrls: ['./view-news.component.scss'],
  providers:[PushNotificationService],
})
export class ViewNewsComponent {

newsDetails:any={};

//for push
message:any = {
  //app_id: "614240e3-c369-44a1-82fb-73227bd2c71c",
  app_id:"05f66e67-3e94-46e5-b53c-52ccfb0ad37c",
  contents: {"en": ""},
  headings:{"en":""},
  included_segments: ["All"],
  data:{"openpage":"activity"}
  
};

testmessage:any = {
  //app_id: "614240e3-c369-44a1-82fb-73227bd2c71c",
  app_id:"05f66e67-3e94-46e5-b53c-52ccfb0ad37c",
  contents: {"en": ""},
  headings:{"en":""},
  included_segments: ["Test"],
  data:{"openpage":"activity"}
  
};

url: any = 'https://onesignal.com/api/v1/notifications';

newsdata: FirebaseObjectObservable<any>;
  constructor(private route: ActivatedRoute,  public router: Router, public af: AngularFireDatabase, private http:Http,public toster: ToastrService, private pushNotification:PushNotificationService) {
  	 	 	this.route.params.map(params => params['id']).subscribe((Id) => {
  	 	 	 	console.log("id" + JSON.stringify(Id));
  	 	if(Id != null) {
        this.newsdata = this.af.object('/FoonYew2Activity/' + Id);
        this.newsdata.subscribe(
        (response) => { 
        	this.newsDetails = response;
           console.log("response" + JSON.stringify(response))
         }
      )
          }
       });
  }
/*
sendPush(message) {
    this.push.sendNotification(message);
  }
*/

onpushNotification(heading,content){
  //console.log("news"+JSON.stringify(this.message));
  this.message.headings={"en":heading};
  this.message.contents={"en":content};

  this.pushNotification.sendNotification(this.message).subscribe(res=>{
    this.toster.success('Notification Send Successfully!', 'Success!');
    })  
  
  }

onTestPushNotification(heading,content){
    //console.log("news"+JSON.stringify(this.message));
    this.testmessage.headings={"en":heading};
    this.testmessage.contents={"en":content};
  
    this.pushNotification.sendNotification(this.testmessage).subscribe(res=>{
      this.toster.success('Test Notification Send Successfully!', 'Success!');
      })  
    
    }

}


// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/app/routes/restaurant/news/view-news/view-news.component.ts